<template>
  <div @click="send" type="primary" class="sendCode" :disabled="s !== up">
    <slot v-if="s === up"></slot>
    <div v-else>{{ s }}秒</div>
  </div>
</template>
<script>
import { get_code } from "@/api/common";

export default {
  props: {
    //手机号
    mobile: {
      type: String,
      default: "",
    },
    //短信类型
    type: {
      type: String,
      default: "",
    },
    // 验证码的默认秒数
    up: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      canSend: false,
      th: null,
      s: 5, // 内部时间
    };
  },
  mounted() {
    this.s = this.up;
  },
  beforeDestroy() {
    clearInterval(this.th);
  },
  methods: {
    async send() {
      var myreg = /^1[3456789]\d{9}$/;
      if (!myreg.test(this.mobile)) {
        this.$message.error("请填写正确的手机号");
        return false;
      }

      try {
        //发送短信
        await get_code({ phone: this.mobile, type: this.type });
        // console.log(res, "短信结果");
        this.canSend = true;
        this.$message.success("短信已发送");
      } catch (e) {
        this.canSend = false;
        this.$message.error("短信发送失败");
      }

      if (this.s === this.up && this.canSend) {
        this.s = this.s - 1;
        // 发送点击事件
        this.$emit("onclick");
        // 周期性减小数字
        this.th = setInterval(() => {
          if (this.s <= 1) {
            this.s = this.up;
            clearInterval(this.th);
          } else {
            this.s = this.s - 1;
          }
        }, 1000);
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
